import { assignmentsListSchema } from '@k2/common/assignments-state/normalizer-schemas';
import { schema } from 'normalizr';

export const k2UserCurrentAssignmentsSchema = new schema.Object({
  working_on: assignmentsListSchema,
  following: assignmentsListSchema,
  team: assignmentsListSchema
});
